import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export type ResultadoDialogAlteracoesNaoSalvas = 'salvar' | 'sair' | 'cancelar';

@Component({
  selector: 'smrts-dialog-alteracoes-nao-salvas',
  templateUrl: './dialog-alteracoes-nao-salvas.component.html',
  styleUrls: ['./dialog-alteracoes-nao-salvas.component.scss'],
  standalone: false,
})
export class DialogAlteracoesNaoSalvasComponent {

  constructor(public dialogRef: MatDialogRef<DialogAlteracoesNaoSalvasComponent, ResultadoDialogAlteracoesNaoSalvas>) { }

  public salvar(): void {
    this.dialogRef.close('salvar');
  }

  public sairSemSalvar(): void {
    this.dialogRef.close('sair');
  }

  public cancelar(): void {
    this.dialogRef.close('cancelar');
  }
}
